// extracted by mini-css-extract-plugin
export default {"loader-container":"Loader_loader-container__cJ9wM","loader":"Loader_loader__5Aapd","spin":"Loader_spin__l2QOk"};